import { ActionDispatching, LoadOptions, RequestApiMethod, RequestRemoteApi } from 'app/types-shared';
import {
  mapToOptionsRequestParams, codeItemToStoreValue, mapToOptionsRequestPayload, mapToCodeListItemWire
} from 'app/infrastructure/data/codes';
import { ErrorNotification } from 'app/infrastructure/notifications/user-messages';
import { api } from './api';
import { RequestCodetable, ReceiveCodetable, FailCodetable } from './action-types';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { mapCategories, mapDescendantCount, mapListToStore } from 'app/components/options-handler/mappers';

export const actionCreatorsFactory = (path: string) => ({
  loadOptions: (
    id: string,
    componentEndpoint: string,
    loadOptionsParams: LoadOptions,
    optionsParams?: any,
    optionsRequestPayload?: any,
    codetableId?: number): ActionDispatching<any, any> =>
    async (dispatch: any, getState: any) => {
      const query = loadOptionsParams && loadOptionsParams.query || '';

      dispatch(new RequestCodetable(path, id, query, loadOptionsParams));

      try {
        const requestApiMethod = loadOptionsParams?.requestApiMethod ?? RequestApiMethod.get;
        const requestRemoteApi = loadOptionsParams?.requestRemoteApi ?? RequestRemoteApi.adminApi;
        const parentId = loadOptionsParams && loadOptionsParams.parentId || undefined;
        const siblingId = loadOptionsParams && loadOptionsParams.siblingId || undefined;

        const request = {
          [RequestApiMethod.get]: () => api.getOptions({
            componentEndpoint: query
              ? `${componentEndpoint}/search`
              : componentEndpoint,
            optionsParams,
            optionsRequestParams: mapToOptionsRequestParams(loadOptionsParams),
            requestRemoteApi
          }),
          [RequestApiMethod.post]:
            () => api.postOptions({
              componentEndpoint,
              optionsParams,
              optionsRequestParams: mapToOptionsRequestParams({ ...loadOptionsParams, query: undefined }),
              optionsRequestPayload: {
                ...mapToOptionsRequestPayload({
                  query: loadOptionsParams?.query,
                  limitFieldsTo: optionsParams?.limitFieldsTo
                }),
                ...optionsRequestPayload
              },
              requestRemoteApi
            })
        }[requestApiMethod];

        const response = await request();
        const wireCodes = mapToCodeListItemWire(response?.data?.results)
          || (response && response.data && response.data.rootCodes || (response && response.data)) || [];

        const getOptionsCodes = {
          [RequestApiMethod.get]: () => mapDescendantCount(mapCategories(wireCodes.map(codeItemToStoreValue), wireCodes), wireCodes),
          [RequestApiMethod.post]: async () => {
            const pathCodes = () => isDefinedIncludingZero(codetableId) && (siblingId !== undefined || parentId !== undefined)
              && api.loadPath(codetableId, siblingId || parentId);

            return mapListToStore(wireCodes, codeItemToStoreValue(await pathCodes()));
          }
        }[requestApiMethod];

        dispatch(new ReceiveCodetable(path, id, query, await getOptionsCodes()));
      } catch (err) {

        err && err.userMessages && dispatch(new ErrorNotification(err.userMessages));
        dispatch(new FailCodetable(path, id, query));
      }
    }
});
